import { configureStore } from "@reduxjs/toolkit";

import applicationTokenSlice from "./slices/applicationTokenSlice";
import loginSlice from "./slices/loginSlice";
import formReducer from './slices/reducer';
import languageReducer from './slices/languageSlice';

export const store = configureStore({
  reducer: {
    form: formReducer,
    appToken: applicationTokenSlice,
    loginData: loginSlice,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Store'un doğru şekilde initialize edildiğini kontrol et
console.log('Redux Store Initialized:', store.getState());

export default store;